import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../LangContext";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/b9279398-bca1-4726-a256-3cb06bf2f4ad/images/df8733ea3b7369b8457b9135909dd6cc610ece94eeda44a5233430f748d0cc3b.png";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay },
});

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-stone50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-12">
          <div className="col-span-12 md:col-span-5">
            <motion.p {...fade(0)} className="eyebrow text-ink2">
              — {t.about.eyebrow}
            </motion.p>
            <motion.h2
              {...fade(0.05)}
              className="headline text-ink mt-6 text-4xl sm:text-5xl lg:text-6xl"
              data-testid="about-title"
            >
              {t.about.title}
            </motion.h2>

            <motion.div {...fade(0.15)} className="mt-10 aspect-[4/5] overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt=""
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </motion.div>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <motion.div {...fade(0.1)} className="space-y-6">
              <p className="text-lg text-ink2 leading-relaxed" data-testid="about-body-1">
                {t.about.body_1}
              </p>
              <p className="text-lg text-ink2 leading-relaxed" data-testid="about-body-2">
                {t.about.body_2}
              </p>
            </motion.div>

            <motion.div
              {...fade(0.25)}
              className="mt-12 border-t border-line"
              data-testid="about-municipalities"
            >
              {t.about.municipalities.map((m, i) => (
                <div
                  key={m}
                  className="flex items-baseline justify-between border-b border-line py-5"
                >
                  <span className="font-serif text-2xl md:text-3xl text-ink">{m}</span>
                  <span className="text-xs uppercase tracking-widest text-ink2">
                    0{i + 1}
                  </span>
                </div>
              ))}
            </motion.div>

            <motion.p
              {...fade(0.35)}
              className="mt-8 text-sm text-ink2 italic"
              data-testid="about-caption"
            >
              {t.about.caption}
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}
